import React from "react"
import Logo from "../Logo"
import SocialLinks from "../SocialLinks"

import * as S from "./styled"

const Footer = () => (
  <S.FooterWrapper>
    <S.FooterContainer>
      <S.FooterColumn>
        <Logo small />
        <SocialLinks />
      </S.FooterColumn>

      <S.FooterGroup>
        <S.FooterList>
          <S.FooterListTitle>&nbsp;</S.FooterListTitle>
          <S.FooterItem>
            <S.FooterIconWhatsapp />
            <S.FooterLink href="https://api.whatsapp.com/send?phone=551140033142&text=Ol%C3%A1,%20gostaria%20de%20conversar%20com%20um%20representante%20de%20vendas">
              4003-3142
            </S.FooterLink>
          </S.FooterItem>
          <S.FooterItem>
            <S.FooterIconMail />
            <S.FooterLink href="mailto:suporte@gendo.com.br?Subject=Dúvidas">
              suporte@gendo.com.br
            </S.FooterLink>
          </S.FooterItem>
        </S.FooterList>

        <S.FooterList>
          <S.FooterListTitle>Gendo</S.FooterListTitle>
          <S.FooterItem>
            <S.FooterLink href="https://www.gendo.com.br/funcoes.html">
              Funções
            </S.FooterLink>
          </S.FooterItem>
          <S.FooterItem>
            <S.FooterLink href="https://www.gendo.com.br/planos.html">
              Planos e Preços
            </S.FooterLink>
          </S.FooterItem>
          <S.FooterItem>
            <S.FooterLink href="https://www.gendo.com.br/termos-de-uso.html">
              Termos de Uso
            </S.FooterLink>
          </S.FooterItem>
        </S.FooterList>

        <S.FooterList>
          <S.FooterListTitle>Mais Informações</S.FooterListTitle>
          <S.FooterItem>
            <S.FooterLink href="https://acesso.gendo.app/">
              Já sou cliente
            </S.FooterLink>
          </S.FooterItem>
          <S.FooterItem>
            <S.FooterLink href="https://gendo.com.br/blog/">Blog</S.FooterLink>
          </S.FooterItem>
          <S.FooterItem>
            <S.FooterLink href="https://ajuda.gendo.com.br/">
              Ajuda
            </S.FooterLink>
          </S.FooterItem>
        </S.FooterList>
      </S.FooterGroup>
    </S.FooterContainer>
    <S.FooterText>
      {" "}
      Gendo: Sistema de Gestão Online para salões de beleza e prestadores de
      serviço <br />
      Copyright © Gendo | SuperAgendador | REW Sistemas de Internet SA{" "}
    </S.FooterText>
  </S.FooterWrapper>
)

export default Footer
